import { apiClient } from '@/lib/api'

/**
 * Client Dictionaries API - States, Client Types, Stages
 */

// States
export const statesApi = {
  getAll: (params = {}) => apiClient.get('/v1/arendators/states/', { params }),
}

// Client Types
export const clientTypesApi = {
  getAll: (params = {}) => apiClient.get('/v1/arendators/client-types/', { params }),
}

// Stages
export const stagesApi = {
  getAll: (params = {}) => apiClient.get('/v1/arendators/stages/', { params }),
}
